<script lang="ts">
    import { onMount } from 'svelte'
    import Icon from '@iconify/svelte'

    import PopEntry from 'hydria/components/PopEntry.svelte'
    import { uuid } from 'hydria/document_helpers'
    import { gettext as _, resolve, tgettext } from 'hydria/services/gettext'

    let value: string = $state('')

    function load(currentValue: string) {
        if (value !== currentValue) value = currentValue
    }

    let label = tgettext('Méta-description')

    interface Props {
        saved: string
        value: string
        disabled?: boolean
        isValid?: any
        save?: (v: string) => void
    }

    let { saved: savedValue = $bindable(), value: currentValue = $bindable(), disabled = false, isValid = (value: string) => true, save }: Props = $props()
    let savedIsValid = isValid(savedValue)
    let open = $state(false)

    function keep() {
        currentValue = value
        if (save) save(currentValue)
        open = false
    }

    const id = uuid('t')
    let element: HTMLElement | undefined = $state()
    onMount(() => {
        load(currentValue)
    })
    let isPristine = $derived(currentValue === savedValue)

    let statusIcon: string = $derived(isPristine ? (savedIsValid ? 'mdi:check-circle' : 'mdi:alert') : isValid(currentValue) ? 'mdi:undo' : 'mdi:undo')
    let statusClass: string = $derived(isPristine ? (savedIsValid ? 'btn-link' : 'btn-danger') : isValid(currentValue) ? 'btn-outline-warning' : 'btn-outline-danger')
</script>

<svelte:window
    onkeydown={(e) => {
        if (e.key == 'Escape' && open) open = false
        else if (e.key == 'Enter' && e.ctrlKey && open) keep()
    }}
/>

<div class="row g-3 align-items-baseline">
    <div class="col-2 text-end"><label aria-hidden="true" for={id} class="control-label" onclick={() => (open = true)}>{$resolve(label)}</label></div>
    <div class="col">
        {#if open}
            <PopEntry
                close={() => (open = false)}
                mounted={() => {
                    if (element) element.focus()
                }}
            >
                <div class="card">
                    <div class="card-header text-bg-primary">{$resolve(label)}</div>
                    <div class="card-body">
                        <textarea class="form-control" bind:value bind:this={element}></textarea>
                        <div class="form-text">{$_('Ce texte aide les moteurs de recherche à créer la description sur leur page. Si absent, un extrait est généré à partir du contenu de la page.')}</div>
                    </div>
                    <div class="card-footer d-flex gap-2 justify-content-end">
                        <button type="button" class="btn btn-sm btn-outline-secondary" onclick={() => (open = false)}>{$_('Fermer')}</button>
                        <button type="button" class="btn btn-sm btn-primary" disabled={!isValid(value)} onclick={() => keep()}>{$_('Appliquer')}</button>
                    </div>
                </div>
            </PopEntry>
        {/if}
        <div aria-hidden="true" ondblclick={() => (open = true)}>
            {#if value && value != ''}
                {value}
            {:else}
                <em class="text-muted">{$_('non-configuré')}</em>
            {/if}
        </div>
        <div class="form-text">{$_('Ce texte aide les moteurs de recherche à créer la description sur leur page. Si absent, un extrait est généré à partir du contenu de la page.')}</div>
    </div>
    <div class="col-auto text-end">
        <button
            type="button"
            class="btn btn-sm {statusClass}"
            disabled={isPristine}
            onclick={() => {
                currentValue = savedValue
            }}><Icon inline icon={statusIcon} /></button
        >
        <button type="button" class="btn btn-sm btn-outline-secondary" {disabled} onclick={() => (open = true)}><Icon inline icon="mdi:edit" /></button>
    </div>
</div>
